export default function GeneralIcon(props: { fill?: string }) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4264_12941)">
        <path
          d="M6.55846 4.09011C6.14194 4.09011 5.86425 4.50692 5.86425 4.7848V8.25821H4.47582V4.7848C4.47582 4.36799 4.19814 4.09011 3.78161 4.09011C3.36508 4.09011 3.0874 4.50692 3.0874 4.7848V8.25821H1.69897V4.7848C1.69897 4.36799 1.42129 4.09011 1.00476 4.09011C0.588232 4.09011 0.310547 4.50692 0.310547 4.7848V9.3697C0.310547 10.6201 1.28244 11.5927 2.39319 11.7316V21.4572C2.39319 22.2908 2.94856 22.8465 3.78161 22.8465C4.61467 22.8465 5.17004 22.2908 5.17004 21.4572V11.7316C6.28078 11.5927 7.25268 10.6201 7.25268 9.3697V4.7848C7.25268 4.50692 6.97499 4.09011 6.55846 4.09011ZM9.33531 4.7848V13.121H10.7237V21.4572C10.7237 22.2908 11.2791 22.8465 12.1122 22.8465C12.9452 22.8465 13.5006 22.2908 13.5006 21.4572V0.616699C11.1403 0.616699 9.33531 2.42287 9.33531 4.7848ZM19.0543 3.39543C17.1105 3.39543 15.5832 5.47948 15.5832 7.98034C15.4444 9.64757 16.2774 11.1759 17.6659 12.1484V21.4572C17.6659 22.2908 18.2212 22.8465 19.0543 22.8465C19.8874 22.8465 20.4427 22.2908 20.4427 21.4572V12.1484C21.8311 11.1759 22.6642 9.64757 22.5254 7.98034C22.5254 5.47948 20.9981 3.39543 19.0543 3.39543Z"
          fill={props.fill ?? 'white'}
        />
      </g>
      <defs>
        <clipPath id="clip0_4264_12941">
          <rect
            width="22.2298"
            height="22.2298"
            fill={props.fill ?? 'white'}
            transform="translate(0.310547 0.616699)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
